import { getLocalTenant, helper } from '../../services/helper';
import { data } from '../../data/tenant.json';

const tenant = getLocalTenant()

const state = {
  currentUser: null,
  currentTenant: tenant,
  dataTenant : data
}

// getters
const getters = {
  getCurrentTenant (state) {
      return state.currentTenant;
  },
  getCurrentUser (state) {
    return state.currentUser;
},
}

// mutations
const mutations = {
  localTenant(state, payload) {
    state.currentTenant = payload
  },
  localUser(state, payload) {
    // let current = helper.getUserObject(payload)
    // console.log(current, 'store user')
    // state.currentUser = current
    state.currentUser = payload
  }
};

// actions
const actions = {
  
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}